import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminGuard({ children, requireSuperAdmin = false }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login", { replace: true });
      return;
    }
    const role = user.role;
    const isAdmin = role === "admin" || role === "super_admin";
    if (!isAdmin) {
      navigate("/dashboard", { replace: true });
      return;
    }
    if (requireSuperAdmin && role !== "super_admin") {
      navigate("/admin", { replace: true });
      return;
    }
    // First-login password change enforcement
    if (user.must_change_password && location.pathname !== "/admin/change-password") {
      navigate("/admin/change-password", { replace: true });
    }
  }, [loading, user, navigate, requireSuperAdmin, location.pathname]);

  if (loading || !user) {
    return (
      <div className="min-h-screen grid place-items-center bg-[hsl(var(--zt-beige))]">
        <Loader2 className="animate-spin text-[hsl(var(--zt-teal))]" size={28} />
      </div>
    );
  }

  const role = user.role;
  const isAdmin = role === "admin" || role === "super_admin";
  if (!isAdmin) return null;
  if (requireSuperAdmin && role !== "super_admin") return null;

  return children;
}
